import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import ArcticIconFont from "@/icon";
import styles from "./index.module.less";

const PointFormItem = ({ value, onChange }) => {
  const { t } = useTranslation();
  const startPointHandler = useCallback(() => {
    onChange?.({ drawing: "start" });
  }, [onChange]);
  const endPointHandler = useCallback(() => {
    onChange?.({ drawing: "end" });
  }, [onChange]);
  const resetStartDrawing = useCallback(() => {
    onChange?.({ drawing: undefined, startPoint: undefined });
  }, [onChange]);
  const resetEndDrawing = useCallback(() => {
    onChange?.({ drawing: undefined, endPoint: undefined });
  }, [onChange]);
  if (!value) return null;
  const { startPoint, endPoint, drawing } = value;

  return (
    <div className={styles.pointFormItem}>
      <div className="setting">
        <span
          className={
            startPoint ? "marker-setting start-validated" : "marker-setting"
          }
        >
          <ArcticIconFont type="icon-marker" />
        </span>
        {drawing === "start" ? (
          <span className="label-setting" onClick={resetStartDrawing}>
            [{t("cancel")}]
          </span>
        ) : (
          <span className="label-setting" onClick={startPointHandler}>
            [{t("setting")}]
          </span>
        )}
      </div>
      <div className="space"> / </div>
      <div className="setting">
        <span
          className={
            endPoint ? "marker-setting end-validated" : "marker-setting"
          }
        >
          <ArcticIconFont type="icon-marker" />
        </span>
        {drawing === "end" ? (
          <span className="label-setting" onClick={resetEndDrawing}>
            [{t("cancel")}]
          </span>
        ) : (
          <span className="label-setting" onClick={endPointHandler}>
            [{t("setting")}]
          </span>
        )}
      </div>
    </div>
  );
};

export default PointFormItem;
